// ==========================================================================
// Tiffin Box Recipes Dataset for Kids & Students (School & College)
// Features morning rush prep, no-sogginess, anti-sour tricks, and balanced boxes
// ==========================================================================

export const TIFFIN_PACKING_TIPS = [
  {
    icon: '❄️',
    title: 'The Cool-Down Rule',
    title_ta: 'சூடு ஆறும் விதிமுறை',
    title_hi: 'ठंडा करने का नियम',
    title_te: 'చల్లార్చే నియమం',
    desc: 'Never seal steaming hot food inside a tiffin box immediately. Trapped steam creates water droplets, making rotis rubbery and rice soggy. Wait 3-5 minutes before packing!',
    desc_ta: 'சூடான உணவை உடனே டிபன் பாக்ஸில் மூடி வைக்காதீர்கள். நீராவி சொட்டுகளாக மாறி சப்பாத்தியை ரப்பர் போலவும், சாதத்தை குழைந்தும் போகச் செய்யும். 3-5 நிமிடம் ஆறிய பின் மூடவும்!'
  },
  {
    icon: '🥛',
    title: 'Curd Rice Anti-Sour Secret',
    title_ta: 'தயிர் சாதம் புளிக்காத ரகசியம்',
    title_hi: 'दही भात खट्टा न होने का राज़',
    title_te: 'పెరుగన్నం పులవకుండా ఉండే చిట్కా',
    desc: 'When mixing curd rice in the morning, blend 70% curd with 30% boiled, cooled milk. By lunchtime (1 PM), it naturally ferments into silky, sweet perfection without turning sour!',
    desc_ta: 'காலையில் தயிர் சாதம் கிளறும்போது 70% தயிருடன் 30% காய்ச்சி ஆறவைத்த பால் சேர்த்து கிளறவும். மதியம் 1 மணிக்கு சாப்பிடும்போது புளிக்காமல் பஞ்சாமிர்தம் போல் சுவையாக இருக்கும்!'
  },
  {
    icon: '🌯',
    title: 'Parchment Wrap for Soft Rolls',
    title_ta: 'பட்டர் பேப்பர் பயன்பாடு',
    title_hi: 'रोल के लिए बटर पेपर',
    title_te: 'చపాతీ రోల్స్ చిట్కా',
    desc: 'Wrap chapati rolls and frankies in parchment or butter paper instead of plastic foil. It lets the roll breathe while preserving softness without turning soggy.',
    desc_ta: 'சப்பாத்தி ரோலை பிளாஸ்டிக்கில் சுற்றாமல் பட்டர் பேப்பரில் சுற்றினால், வியர்வை நீர்த்துளி படியாமல் கடைசி வாய் வரை பஞ்சு போல் மென்மையாக இருக்கும்.'
  },
  {
    icon: '🍎',
    title: 'Non-Browning Fruit Hack',
    title_ta: 'ஆப்பிள் கருக்காமல் இருக்க',
    title_hi: 'सेब काला न पड़ने का नुस्खा',
    title_te: 'యాపిల్ ముక్కలు నల్లబడకుండా',
    desc: 'Soak sliced apples or pears in a bowl of water with 2 drops of lemon juice or a pinch of salt for 30 seconds. They stay bright, golden and crisp till lunch break!',
    desc_ta: 'நறுக்கிய ஆப்பிள் துண்டுகளை சில துளிகள் எலுமிச்சை சாறு கலந்த நீரில் 30 விநாடி நனைத்து வைத்தால் மதியம் வரை நிறம் மாறாமல் மொறுமொறுவென இருக்கும்.'
  },
  {
    icon: '🍱',
    title: 'Separate Dry Crunch Pouch',
    title_ta: 'அப்பளம் & சிப்ஸ் தனியாக வைக்க',
    title_hi: 'पापड़-चिप्स के लिए अलग पाउच',
    title_te: 'అప్పడం క్రంచీగా ఉండాలంటే',
    desc: 'Always pack fryums, appalams, mixture, or sev in a small separate dry ziplock bag inside the box so moisture from rice never makes them limp.',
    desc_ta: 'அப்பளம், சிப்ஸ் அல்லது மிக்ஸரை எப்போதும் ஒரு சிறிய ஜிப்லாக் கவர் அல்லது பேப்பரில் தனியாக வைத்தால் நமுத்துப்போகாமல் மொறுமொறுவென இருக்கும்.'
  }
];

export const TIFFIN_RECIPES = [
  {
    id: 'tiffin-1',
    recipeId: 1,
    coreDish: 'Idli',
    title: 'Mini Ghee Podi Idlis + Pomegranate',
    title_ta: 'மினி நெய் பொடி இட்லி + மாதுளை பாக்ஸ்',
    title_hi: 'मिनी घी पोड़ी इडली + अनार टिफिन',
    title_te: 'మినీ గీ పొడి ఇడ్లీ + దానిమ్మ బాక్స్',
    audience: 'school',
    audienceLabel: '🎒 School Kids',
    audienceLabel_ta: '🎒 பள்ளி குழந்தைகள் (4-12 வயது)',
    prepTime: '15m',
    stayFresh: '5 Hours Soft',
    stayFresh_ta: '5 மணிநேரம் பஞ்சு போல் மிருது',
    badge: 'Bite-Sized & Zero Spill',
    badge_ta: 'சிந்தாமல் சாப்பிடலாம் & சுலபம்',
    diet: 'Vegetarian',
    rating: 4.9,
    mainItem: '20 Button Mini Idlis gently tossed in pure desi ghee and mild gun powder (idli podi).',
    mainItem_ta: '20 மினி இட்லிகள் சுத்தமான நெய் மற்றும் இட்லி பொடியில் வதக்கியது.',
    side1: 'Fresh ruby pomegranate pearls (natural sweet crunch & iron).',
    side1_ta: 'சுவையான மாதுளை முத்துக்கள் (இயற்கை இனிப்பு & இரும்புச்சத்து).',
    side2: 'Crispy cucumber sticks or roasted cashews.',
    side2_ta: 'வெள்ளரிக்காய் துண்டுகள் அல்லது வறுத்த முந்திரி.',
    packTip: 'Allow idlis to cool for 3 minutes before packing. Prevents moisture condensation inside the box.',
    packTip_ta: 'இட்லியை 3 நிமிடம் ஆறவைத்து டிபன் பாக்ஸில் வைத்தால் வியர்த்து போகாமல் மதியம் வரை பஞ்சு போல் இருக்கும்.',
    image: '/images/recipes/recipe_1.jpg',
    quickSteps: [
      { step: '1', text: 'Steam 20 mini idlis in a mini idli plate for 7 minutes.' },
      { step: '2', text: 'In a pan, warm 1 tsp ghee, add mild idli podi and toss steamed idlis for 30 seconds.' },
      { step: '3', text: 'Cool for 3 mins, pack alongside fresh pomegranate and cucumber sticks.' }
    ]
  },
  {
    id: 'tiffin-2',
    recipeId: 36,
    coreDish: 'Chapati with Vegetable Curry',
    title: 'Paneer & Carrot Chapati Pinwheels',
    title_ta: 'பன்னீர் & கேரட் சப்பாத்தி ரோல்',
    title_hi: 'पनीर और गाजर चपाती रोल',
    title_te: 'పన్నీర్ மற்றும் క్యారెట్ చపాతీ రోల్',
    audience: 'school',
    audienceLabel: '🎒 School Kids',
    audienceLabel_ta: '🎒 பள்ளி குழந்தைகள் (4-12 வயது)',
    prepTime: '15m',
    stayFresh: '6 Hours Fresh',
    stayFresh_ta: '6 மணிநேரம் சாஃப்ட்',
    badge: 'High Protein & Vit-A',
    badge_ta: 'புரதச்சத்து & வைட்டமின் A',
    diet: 'Vegetarian',
    rating: 4.8,
    mainItem: 'Soft whole wheat chapati smeared with mild spiced paneer bhurji & finely grated crunchy carrots, tightly rolled.',
    mainItem_ta: 'மிருதுவான சப்பாத்தியில் தூவிய பன்னீர் மற்றும் துருவிய கேரட் மசாலா வைத்து சுருட்டிய ரோல்.',
    side1: 'Sweet green seedless grapes.',
    side1_ta: 'இனிப்பான பச்சை திராட்சை பழங்கள்.',
    side2: 'Dry fruit dates or roasted almonds.',
    side2_ta: 'உலர் பேரீச்சம்பழம் அல்லது பாதாம்.',
    packTip: 'Wrap each roll in parchment paper instead of foil so it breathes and stays soft without moisture.',
    packTip_ta: 'சப்பாத்தி ரோலை பட்டர் பேப்பரில் சுற்றி வைத்தால் கசிவு இல்லாமல் மென்மையாக இருக்கும்.',
    image: '/images/recipes/recipe_36.jpg',
    quickSteps: [
      { step: '1', text: 'Knead soft dough with warm milk/water and roll out thin chapatis.' },
      { step: '2', text: 'Toss crumbled paneer with grated carrots, mild cumin powder and a pinch of salt.' },
      { step: '3', text: 'Spread filling on warm chapati, roll tightly, slice into bite-sized pinwheels and wrap.' }
    ]
  },
  {
    id: 'tiffin-3',
    recipeId: 51,
    coreDish: 'Curd Rice',
    title: 'Creamy Tempered Curd Rice + Fryums',
    title_ta: 'தாளித்த தயிர் சாதம் + மாதுளை & அப்பளம்',
    title_hi: 'तड़का कर्ड राइस + अनार और फ्रायम्स',
    title_te: 'తాలింపు పెరుగన్నం + దానిమ్మ',
    audience: 'school',
    audienceLabel: '🎒 School Kids',
    audienceLabel_ta: '🎒 பள்ளி குழந்தைகள் (4-12 வயது)',
    prepTime: '10m',
    stayFresh: '6 Hours (Anti-Sour)',
    stayFresh_ta: '6 மணிநேரம் புளிக்காமல் இருக்கும்',
    badge: 'Gut Cooling & Probiotic',
    badge_ta: 'வயிறு குளிர்ச்சி & செரிமானம்',
    diet: 'Vegetarian',
    rating: 5.0,
    mainItem: 'Creamy mashed rice mixed with fresh curd and a splash of milk, tempered with mustard seeds, ginger & curry leaves.',
    mainItem_ta: 'பால் கலந்து தாளித்த தயிர் சாதம் (கடுகு, இஞ்சி, கறிவேப்பிலை வாசனையுடன்).',
    side1: 'Sweet pomegranate pearls mixed on top.',
    side1_ta: 'மேலே தூவப்பட்ட மாதுளை முத்துக்கள்.',
    side2: 'Crispy sun-dried fryums packed in a dry paper wrap.',
    side2_ta: 'தனியாக சிறிய கவரில் வைக்கப்பட்ட மொறுமொறு அப்பளம்/வத்தல்.',
    packTip: 'Add 30% boiled cooled milk with 70% curd while mixing in morning. Ferments to sweet perfection by lunchtime!',
    packTip_ta: 'காலையில் கலக்கும்போது 30% பால் சேர்த்தால் மதியம் வரை புளிக்காமல் சுவையாக இருக்கும்!',
    image: '/images/recipes/recipe_51.jpg',
    quickSteps: [
      { step: '1', text: 'Mash warm cooked rice with a potato masher until soft and creamy.' },
      { step: '2', text: 'Mix in fresh curd, 1/4 cup boiled milk, and salt to taste.' },
      { step: '3', text: 'Temper mustard, cumin, curry leaves, grated ginger in ghee and pour over. Top with pomegranate.' }
    ]
  },
  {
    id: 'tiffin-4',
    recipeId: 31,
    coreDish: 'Vegetable Poha',
    title: 'Sweet Corn & Green Peas Poha',
    title_ta: 'ஸ்வீட் கார்ன் & பட்டாணி அவல் + வேர்க்கடலை',
    title_hi: 'स्वीट कॉर्न पोहा + भुनी मूंगफली',
    title_te: 'స్వీట్ కార్న్ పోహా + పల్లీలు',
    audience: 'school',
    audienceLabel: '🎒 School Kids',
    audienceLabel_ta: '🎒 பள்ளி குழந்தைகள் (4-12 வயது)',
    prepTime: '12m',
    stayFresh: '5 Hours Fluffy',
    stayFresh_ta: '5 மணிநேரம் உதிரியாக இருக்கும்',
    badge: 'Iron Rich & Light',
    badge_ta: 'இரும்புச்சத்து & லேசான உணவு',
    diet: 'Vegetarian',
    rating: 4.7,
    mainItem: 'Fluffy flattened rice tossed with sweet corn, green peas, turmeric, lemon zest and crunchy roasted peanuts.',
    mainItem_ta: 'சோளம், பட்டாணி, எலுமிச்சை சாறு மற்றும் வறுத்த நிலக்கடலையுடன் வதக்கிய மெதுவான அவல்.',
    side1: 'Thin apple wedges with a drop of lemon juice (prevents browning).',
    side1_ta: 'கருக்காமல் இருக்க லேசாக எலுமிச்சை தடவிய ஆப்பிள் துண்டுகள்.',
    side2: 'Crisp fine sev packed in a dry wrapper.',
    side2_ta: 'தனியாக சிறிய பாக்ஸில் ஓமப்பொடி / மிக்ஸர்.',
    packTip: 'Sprinkle 1 tsp warm water before sealing the box to keep the poha moist and soft till afternoon.',
    packTip_ta: 'அவல் காய்ந்து போகாமல் இருக்க பேக் செய்யும் முன் லேசாக தண்ணீர் தெளித்து மூடவும்.',
    image: '/images/recipes/recipe_31.jpg',
    quickSteps: [
      { step: '1', text: 'Rinse thick poha in a colander for 30 seconds and drain well.' },
      { step: '2', text: 'In oil, temper mustard, peanuts, turmeric, sweet corn and steamed green peas for 2 mins.' },
      { step: '3', text: 'Add rinsed poha, salt, squeeze lemon juice, toss gently on low flame for 1 minute and pack.' }
    ]
  },
  {
    id: 'tiffin-5',
    recipeId: 46,
    coreDish: 'Tomato Rice',
    title: 'Mild Thakkali Sadam + Potato Coins',
    title_ta: 'தக்காளி சாதம் + உருளை வறுவல் / முட்டை',
    title_hi: 'टमाटर भात + आलू फ्राई / उबला अंडा',
    title_te: 'టమోటా రైస్ + ఆలుగడ్డ వేపుడు',
    audience: 'school',
    audienceLabel: '🎒 School Kids',
    audienceLabel_ta: '🎒 பள்ளி குழந்தைகள் (4-12 வயது)',
    prepTime: '20m',
    stayFresh: '6 Hours Aromatic',
    stayFresh_ta: '6 மணிநேரம் மணம் மாறாது',
    badge: 'Kids #1 Favorite',
    badge_ta: 'குழந்தைகளின் ஃபேவரிட்',
    diet: 'Vegetarian',
    rating: 4.9,
    mainItem: 'Fragrant ponni rice slow-simmered in sweet and tangy tomato gravy with mild spices and ghee.',
    mainItem_ta: 'பழுத்த தக்காளி தொக்கு மற்றும் நெய்யில் கலந்த நறுமண தக்காளி சாதம்.',
    side1: 'Crisp golden potato coin fry or sliced hard-boiled egg.',
    side1_ta: 'வட்ட உருளைக்கிழங்கு வறுவல் அல்லது அவித்த முட்டை.',
    side2: 'Crunchy carrot slices or roasted peanuts.',
    side2_ta: 'கேரட் துண்டுகள் அல்லது வறுத்த கடலை.',
    packTip: 'Cook rice 90% firm so tomato sauce absorbs without turning pasty in the lunchbox.',
    packTip_ta: 'சாதத்தை உதிரியாக வடித்து தக்காளி தொக்குடன் கலந்தால் குலையாமல் தனித்தனியாக இருக்கும்.',
    image: '/images/recipes/recipe_46.jpg',
    quickSteps: [
      { step: '1', text: 'Sauté onions, ginger-garlic, ripe chopped tomatoes until mushy and oil separates.' },
      { step: '2', text: 'Add 1/4 tsp garam masala, coriander powder, salt, and 1 tsp ghee.' },
      { step: '3', text: 'Mix in cooked cooled rice gently, let cool 3 mins, and pack with potato coins.' }
    ]
  },
  {
    id: 'tiffin-6',
    recipeId: 146,
    coreDish: 'One-Pot Vegetable Khichdi',
    title: 'Ghee Moong Dal Vegetable Khichdi',
    title_ta: 'நெய் பாசிப்பருப்பு காய்கறி கிச்சடி',
    title_hi: 'देसी घी वेज मूंग दाल खिचड़ी',
    title_te: 'నెయ్యి పెసరపప్పు కూరగాయల కిచిడీ',
    audience: 'school',
    audienceLabel: '🎒 School Kids',
    audienceLabel_ta: '🎒 பள்ளி குழந்தைகள் (4-12 வயது)',
    prepTime: '18m',
    stayFresh: '5 Hours Soft',
    stayFresh_ta: '5 மணிநேரம் மிருதுவாக இருக்கும்',
    badge: 'Super Digestive & Nutritious',
    badge_ta: 'எளிதில் செரிக்கும் சத்துணவு',
    diet: 'Vegetarian',
    rating: 4.8,
    mainItem: 'Pressure-cooked rice & split yellow moong dal with finely chopped carrots, green beans, cumin & aromatic ghee.',
    mainItem_ta: 'பாசிப்பருப்பு, பொடியாக நறுக்கிய காய்கறிகள், சீரகம் மற்றும் நெய் மணக்கும் சத்தான கிச்சடி.',
    side1: 'Roasted mini appalam or sweet curd dip.',
    side1_ta: 'வறுத்த சிறிய அப்பளம் அல்லது தயிர்.',
    side2: 'Sweet soft dates.',
    side2_ta: 'பேரீச்சம்பழம்.',
    packTip: 'Use a thermal insulated steel lunchbox to keep khichdi warm and soft until lunchtime.',
    packTip_ta: 'இன்சுலேட்டட் டிபன் பாக்ஸில் வைத்தால் மதியம் வரை கதகதப்பாக இருக்கும்.',
    image: '/images/recipes/recipe_146.jpg',
    quickSteps: [
      { step: '1', text: 'Roast yellow moong dal for 1 min until fragrant; mix with washed rice.' },
      { step: '2', text: 'In pressure cooker, heat ghee, temper cumin, add carrots, beans, turmeric and water.' },
      { step: '3', text: 'Cook for 4 whistles until mushy, mash lightly with ghee, and pack.' }
    ]
  },
  {
    id: 'tiffin-7',
    recipeId: 41,
    coreDish: 'Lemon Rice',
    title: 'Crunchy Peanut Lemon Rice + Urulai Roast',
    title_ta: 'வேர்க்கடலை எலுமிச்சை சாதம் + உருளை வறுவல்',
    title_hi: 'लेमन राइस + क्रिस्पी आलू रोस्ट',
    title_te: 'లెమన్ రైస్ + బంగాళాదుంప వేపుడు',
    audience: 'college',
    audienceLabel: '🎓 College & Hostel',
    audienceLabel_ta: '🎓 கல்லூரி & விடுதி மாணவர்கள்',
    prepTime: '15m',
    stayFresh: '8 Hours Stays Fresh',
    stayFresh_ta: '8 மணிநேரம் கெட்டுப்போகாது',
    badge: 'No Fridge Needed',
    badge_ta: 'பிரிட்ஜ் தேவையில்லை',
    diet: 'Vegetarian',
    rating: 5.0,
    mainItem: 'Zesty turmeric lemon rice with fried peanuts, split urad dal, curry leaves and green chillies in gingelly oil.',
    mainItem_ta: 'நல்லெண்ணெய், வேர்க்கடலை, உளுந்து, பச்சை மிளகாய் தாளித்த பாரம்பரிய எலுமிச்சை சாதம்.',
    side1: 'Spicy pan-roasted potato cubes (Urulai Roast).',
    side1_ta: 'காரசாரமான உருளைக்கிழங்கு வறுவல்.',
    side2: 'Garlic fryums or spicy mango pickle.',
    side2_ta: 'பூண்டு அப்பளம் அல்லது மாங்காய் ஊறுகாய்.',
    packTip: 'Turn off stove and let rice cool slightly before adding fresh lemon juice to avoid any bitterness.',
    packTip_ta: 'அடுப்பை அணைத்து சாதம் ஆறிய பின் எலுமிச்சை சாறு சேர்த்தால் கசப்பு வராது.',
    image: '/images/recipes/recipe_41.jpg',
    quickSteps: [
      { step: '1', text: 'Spread cooked rice on a wide plate to cool completely.' },
      { step: '2', text: 'In gingelly oil, fry peanuts, mustard, chana dal, urad dal, green chillies, curry leaves and turmeric.' },
      { step: '3', text: 'Pour over rice, add salt, squeeze fresh lemon juice, mix gently and pack.' }
    ]
  },
  {
    id: 'tiffin-8',
    recipeId: 71,
    coreDish: 'Egg Rice',
    title: 'Quick Street-Style Egg Masala Rice',
    title_ta: 'துரித முட்டை மசாலா சாதம்',
    title_hi: 'क्विक स्ट्रीट स्टाइल एग फ्राइड राइस',
    title_te: 'స్పైసీ ఎగ్ మసాలా రైస్',
    audience: 'college',
    audienceLabel: '🎓 College & Hostel',
    audienceLabel_ta: '🎓 கல்லூரி & விடுதி மாணவர்கள்',
    prepTime: '15m',
    stayFresh: '6 Hours Flavorful',
    stayFresh_ta: '6 மணிநேரம் மணம் மாறாது',
    badge: '16g High Protein',
    badge_ta: '16g அதிக புரதச்சத்து',
    diet: 'Non-Vegetarian',
    rating: 4.9,
    mainItem: 'Wok-tossed steamed rice with double scrambled eggs, crushed black pepper, chopped onions, and soy-garlic seasoning.',
    mainItem_ta: 'இரண்டு முட்டைகள், நறுக்கிய வெங்காயம், மிளகுத்தூள் சேர்த்து ஹை-ஃப்ளேமில் வதக்கிய சுவை சாதம்.',
    side1: 'Fresh cucumber and onion slices with lemon & chaat masala.',
    side1_ta: 'எலுமிச்சை பிழிந்த வெள்ளரி மற்றும் வெங்காய சாலட்.',
    side2: 'Boiled egg halved with freshly crushed pepper.',
    side2_ta: 'மிளகுத்தூள் தூவிய அவித்த முட்டை.',
    packTip: 'Use cold refrigerated leftover rice for that authentic non-sticky restaurant texture!',
    packTip_ta: 'முந்தைய நாள் உதிரியான சாதத்தை பயன்படுத்தினால் சாதம் ஒட்டாமல் ஹோட்டல் ஸ்டைலில் வரும்!',
    image: '/images/recipes/recipe_71.jpg',
    quickSteps: [
      { step: '1', text: 'Scramble 2 eggs in oil with salt and pepper in a hot wok; set aside.' },
      { step: '2', text: 'Sauté chopped garlic, onions, and green chillies on high flame for 1 min.' },
      { step: '3', text: 'Add cooked cold rice, scrambled eggs, pepper powder, soy sauce, toss well and pack.' }
    ]
  },
  {
    id: 'tiffin-9',
    recipeId: 131,
    coreDish: 'Paneer/Tofu Pepper Fry',
    title: 'Spicy Paneer Tikka Wrap / Franky',
    title_ta: 'காரசார பன்னீர் டிக்கா ராப் / ஃபிராங்கி',
    title_hi: 'मसालेदार पनीर टिक्का रोल',
    title_te: 'స్పైసీ పన్నీర్ టిక్కా రాప్',
    audience: 'college',
    audienceLabel: '🎓 College & Hostel',
    audienceLabel_ta: '🎓 கல்லூரி & விடுதி மாணவர்கள்',
    prepTime: '15m',
    stayFresh: '6 Hours Soft',
    stayFresh_ta: '6 மணிநேரம் சாஃப்ட்',
    badge: '20g Muscle Fuel',
    badge_ta: '20g தசை வளர்ச்சிக்கு புரதம்',
    diet: 'Vegetarian',
    rating: 4.9,
    mainItem: 'Tender paneer cubes pan-tossed in black pepper, bell peppers and chaat masala, rolled in whole wheat roti with mint spread.',
    mainItem_ta: 'மிளகுத்தூள், குடைமிளகாய் மற்றும் மசாலாக்களில் வதக்கிய பன்னீர் சப்பாத்தியில் வைத்து சுருட்டிய ராப்.',
    side1: 'Spiced roasted makhana or peanuts.',
    side1_ta: 'வறுத்த மக்கானா அல்லது வேர்க்கடலை.',
    side2: 'Fresh banana or orange.',
    side2_ta: 'பழம் (வாழைப்பழம் / ஆரஞ்சு).',
    packTip: 'Toast both sides of roti lightly with ghee before rolling to keep it moist and avoid cracking.',
    packTip_ta: 'ரோல் செய்வதற்கு முன் சப்பாத்தியில் லேசாக நெய் தடவினால் விரிசல் விழாமல் மென்மையாக இருக்கும்.',
    image: '/images/recipes/recipe_131.jpg',
    quickSteps: [
      { step: '1', text: 'Pan-fry paneer cubes with pepper, turmeric, chaat masala, and sliced bell peppers.' },
      { step: '2', text: 'Warm a soft whole wheat roti, spread mint chutney or mayo.' },
      { step: '3', text: 'Place filling in center with onion rings, roll tight and wrap in parchment paper.' }
    ]
  },
  {
    id: 'tiffin-10',
    recipeId: 61,
    coreDish: 'Tamarind Rice',
    title: 'Temple-Style Puliyodharai + Appalam Box',
    title_ta: 'கோவில் புளியோதரை + மொறுமொறு அப்பளம்',
    title_hi: 'मंदिर स्टाइल पुलियोधरे + पापड़',
    title_te: 'గుడి శైలి పులిహోర + అప్పడం',
    audience: 'college',
    audienceLabel: '🎓 College & Hostel',
    audienceLabel_ta: '🎓 கல்லூரி & விடுதி மாணவர்கள்',
    prepTime: '15m',
    stayFresh: '12 Hours (Never Spoils)',
    stayFresh_ta: '12 மணிநேரம் கெட்டுப்போகாது',
    badge: 'Legendary Shelf-Life',
    badge_ta: 'முழு நாள் கெடாத சுவை',
    diet: 'Vegetarian',
    rating: 5.0,
    mainItem: 'Aged tamarind pulikachal paste mixed into hot rice with generous sesame oil, roasted peanuts, chana dal and dry chillies.',
    mainItem_ta: 'நல்லெண்ணெய், புளிக்காய்ச்சல், வேர்க்கடலை மற்றும் வறுத்த மிளகாய் கலந்த பாரம்பரிய புளியோதரை.',
    side1: 'Crispy fried appalams in a separate zip-lock pouch.',
    side1_ta: 'தனியாக வைக்கப்பட்ட மொறுமொறு அப்பளம்.',
    side2: 'Spiced boiled chickpeas (sundal).',
    side2_ta: 'தாளித்த கொண்டைக்கடலை சுண்டல்.',
    packTip: 'Puliyodharai tastes even better by afternoon as the tamarind flavors infuse deeply into the rice!',
    packTip_ta: 'புளியோதரை காலையை விட மதியம் ஊற ஊறத்தான் அசல் கோவில் சுவையைத் தரும்!',
    image: '/images/recipes/recipe_61.jpg',
    quickSteps: [
      { step: '1', text: 'Cook ponni rice firm with 1 tsp sesame oil and turmeric; spread to cool.' },
      { step: '2', text: 'Warm 2 tbsp authentic pulikachal paste with 1 tbsp gingelly oil.' },
      { step: '3', text: 'Mix thoroughly with roasted peanuts, curry leaves, and pack with dry appalams.' }
    ]
  },
  {
    id: 'tiffin-11',
    recipeId: 26,
    coreDish: 'Egg Dosa',
    title: 'Egg Roti Roll with Sliced Crunchy Onions',
    title_ta: 'முட்டை சப்பாத்தி ரோல் + வெங்காய மசாலா',
    title_hi: 'एग पराठा रोल + क्रंची प्याज',
    title_te: 'ఎగ్ చపాతీ రోల్ + ఉల్లిపాయలు',
    audience: 'college',
    audienceLabel: '🎓 College & Hostel',
    audienceLabel_ta: '🎓 கல்லூரி & விடுதி மாணவர்கள்',
    prepTime: '12m',
    stayFresh: '6 Hours Soft',
    stayFresh_ta: '6 மணிநேரம் சாஃப்ட்',
    badge: '12-Min Quick Rush',
    badge_ta: '12 நிமிட துரித தயாரிப்பு',
    diet: 'Non-Vegetarian',
    rating: 4.8,
    mainItem: 'Beaten egg with salt and pepper cooked directly over hot roti, sprinkled with thinly sliced raw onions and lemon juice.',
    mainItem_ta: 'சப்பாத்தி மேல் முட்டையை ஊற்றி ஆம்லெட் போல் சுட்டு, வெங்காயம், எலுமிச்சை சாறு சேர்த்து சுருட்டிய ரோல்.',
    side1: 'Fresh apple or banana.',
    side1_ta: 'ஆப்பிள் அல்லது வாழைப்பழம்.',
    side2: 'Mixed nuts and raisins.',
    side2_ta: 'நட்ஸ் & உலர் பழங்கள்.',
    packTip: 'Wrap in foil paper to retain warmth for up to 4 hours in college bags.',
    packTip_ta: 'ஃபாயில் பேப்பரில் சுற்றினால் கல்லூரி பையில் 4 மணிநேரம் வரை கதகதப்பாக இருக்கும்.',
    image: '/images/recipes/recipe_26.jpg',
    quickSteps: [
      { step: '1', text: 'Whisk 1 egg with salt, crushed pepper and green chilli.' },
      { step: '2', text: 'Pour on tawa, press a cooked chapati over it, and flip to cook egg side.' },
      { step: '3', text: 'Sprinkle sliced onions, chaat masala, roll tightly and wrap in foil.' }
    ]
  },
  {
    id: 'tiffin-12',
    recipeId: 66,
    coreDish: 'Vegetable Rice',
    title: 'Mild Veg Pulao + Boiled Egg Box',
    title_ta: 'காய்கறி புலாவ் + அவித்த முட்டை & சிப்ஸ்',
    title_hi: 'वेज पुलाव + उबला अंडा',
    title_te: 'కూరగాయల పులావ్ + ఉడికించిన గుడ్డు',
    audience: 'college',
    audienceLabel: '🎓 College & Hostel',
    audienceLabel_ta: '🎓 கல்லூரி & விடுதி மாணவர்கள்',
    prepTime: '20m',
    stayFresh: '6 Hours Aromatic',
    stayFresh_ta: '6 மணிநேரம் நறுமணம்',
    badge: 'Balanced Meal',
    badge_ta: 'முழுமையான ஆரோக்கிய உணவு',
    diet: 'Vegetarian',
    rating: 4.8,
    mainItem: 'Fragrant basmati rice gently spiced with whole cloves, cardamom, green peas, carrots and french beans.',
    mainItem_ta: 'பட்டை, கிராம்பு, பட்டாணி, கேரட், பீன்ஸ் சேர்த்து சமைத்த மணக்க மணக்க வெஜிடபிள் சாதம்.',
    side1: 'Hard-boiled egg or roasted potato coins.',
    side1_ta: 'அவித்த முட்டை அல்லது உருளை வறுவல்.',
    side2: 'Crispy potato wafers / chips.',
    side2_ta: 'உருளைக்கிழங்கு சிப்ஸ்.',
    packTip: 'Do not pack watery raitha in lunchboxes; instead pack set curd or a boiled egg.',
    packTip_ta: 'வெங்காய பச்சடி நீர்த்துப்போகும் என்பதால், கெட்டி தயிர் அல்லது அவித்த முட்டை வைப்பது சிறந்தது.',
    image: '/images/recipes/recipe_66.jpg',
    quickSteps: [
      { step: '1', text: 'Sauté whole spices, onions, mint leaves, and vegetables in 1 tsp ghee.' },
      { step: '2', text: 'Add soaked basmati rice, water, and salt; pressure cook for 1 whistle.' },
      { step: '3', text: 'Gently fluff with a fork, allow steam to escape for 3 mins, and pack.' }
    ]
  }
];

